export default {"src":"/_next/static/media/apple.9d08f235.svg","height":512,"width":384};